import { useContext } from 'react';
import { AdminContext } from './context';

const useAdmin = () =>
  useContext(AdminContext);

export default useAdmin;
